import { render, staticRenderFns } from "./TitleDescription.vue?vue&type=template&id=6f090caa&scoped=true&"
import script from "./TitleDescription.vue?vue&type=script&lang=js&"
export * from "./TitleDescription.vue?vue&type=script&lang=js&"
import style0 from "./TitleDescription.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TitleDescription.vue?vue&type=style&index=1&id=6f090caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f090caa",
  null
  
)

export default component.exports